import { render } from "./CouponInfo.vue?vue&type=template&id=5c795be4&scoped=true&ts=true"
import script from "./CouponInfo.vue?vue&type=script&lang=ts"
export * from "./CouponInfo.vue?vue&type=script&lang=ts"

import "./CouponInfo.vue?vue&type=style&index=0&id=5c795be4&scoped=true&lang=css"

import exportComponent from "C:\\Users\\hori_taiki\\Desktop\\小野写真館\\環境構築\\point-front-app\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-5c795be4"]])

export default __exports__